import { BrowserRouter } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom';
import DashboardLayout from '../layouts/DashboardLayout';
import Root from '../pages/root';
import * as Pages from '../pages';

import { ErrorPage } from '../components/page/ErrorPage';
import { Settings, WelcomePage } from '../pages';
import React from 'react';
import OnboardingScreen from '../pages/onboardingScreen';
import ViewInventoryPage from '../pages/inventories/view';
import ReportPage from '../pages/reports/ReportsPage';
import { CreateInventoryPage } from '../pages/inventories/create';
import {ListInventoryPage} from '../pages/inventories/list';

import SubscriptionPage from '../pages/Subscription';


interface RouterProps {}

const Router: React.FC<RouterProps> = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* AUTHENTICATION ROUTES */}
        <Route path="auth" element={<Root />}>
          <Route path="" element={<Pages.AuthPage />} />
          <Route path="register" element={<Pages.AuthPage />} />
          <Route path="login" element={<Pages.AuthPage />} />
          <Route path="forget-password" element={<Pages.ForgetPasswordPage />} />
          <Route path="reset-password" element={<Pages.ResetPasswordPage />} />
          <Route path="confirm-account" element={<Pages.ConfirmAccountPage />} />
          <Route path="business-layout" element={<OnboardingScreen />} />
        </Route>

             {/* ONBOARDING ROUTES */}
             <Route path="/businessLayout">
             <Route path="" element={<OnboardingScreen />} />
             </Route>

        {/* DASHBOARD ROUTES */}
        <Route path="" element={<DashboardLayout />} errorElement={<Pages.ErrorPage />}>
          <Route path="/dashboard">
            <Route path="" element={<Pages.DashboardPage />} />
          </Route>

          {/* HomePage Route */}
          <Route path="/welcomePage">
            <Route path="" element={<WelcomePage />} />
          </Route>

          {/* INVOICE ROUTES */}
          <Route path="invoices">
            <Route path="" element={<Pages.ListInvoicePage />} />
            <Route path="create" element={<Pages.CreateInvoicePage />} />
            <Route path=":invoiceNo/view" element={<Pages.ViewInvoicePage />} />
            <Route path="send" element={<Pages.SendInvoicePage />} />
            <Route path="notification/:createdInvoiceId" element={<Pages.InvoiceNotificationPage />} />
            <Route path=":invoiceNo" element={<Pages.DraftInvoicePage />} />
          </Route>

          {/* EXPENSES ROUTES  */}
          <Route path="expenses">
            <Route path="" element={<Pages.ViewExpensePage />} />
            <Route path="create" element={<Pages.CreateNewExpensePage />} />
            <Route path=":expenseId/view" element={<Pages.ViewExpense />} />
            <Route path="edit/:expenseId" element={<Pages.EditExpensePage />} />
            <Route path="test/expense" element={<Pages.ViewExpense />} />
            <Route path="notification/:updatedId" element={<Pages.ExpenseNotificationPage />} />
          </Route>

          {/* CUSTOMERS ROUTES */}
          <Route path="customers">
            <Route path="" element={<Pages.ViewCustomersPages />} />
            <Route path=":customerId/view" element={<Pages.ViewCustomers />} />
          </Route>

          {/* INVENTORY ROUTES */}
          <Route path="inventories">
            <Route path="" element={<ListInventoryPage />} />
            <Route path=":inventoryId/view" element={<ViewInventoryPage />} />
            <Route path="create" element={<CreateInventoryPage />} />

          </Route>
            

          {/* SETTINGS ROUTES */}
          <Route path="settings" element={<Settings />} />
          <Route path='/reports' element={<ReportPage/>}/>

        </Route>

        {/* SUBSCRIPTION ROUTES */}
        <Route path='Subscription'>
           <Route path='' element={<SubscriptionPage/>}/>
        </Route>
        {/* ERROR ROUTE */}
        <Route
          path="*"
          element={
            <ErrorPage
              statusCode={404}
              errorTitle={'Page Not Found'}
              errorText={'Oops, sorry! We couldn’t find this page.'}
              actionButton={
                <button className="inline-flex items-center px-6 py-3 mt-1 text-base font-medium text-white">
                  Go back
                </button>
              }
            />
          }
        />
        <Route
          path="/error"
          element={
            <ErrorPage
              statusCode={500}
              errorTitle={'Internal Server Error'}
              errorText={"Oops seems like something went wrong. We're working on it."}
              actionButton={
                <button className="inline-flex items-center px-6 py-3 mt-1 text-base font-medium text-white">
                  Go back
                </button>
              }
            />
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
